import PropTypes from 'prop-types';

import { accountShape } from 'Workspace/types/account';

const cohortSummaryShape = PropTypes.shape({
  cohortId: PropTypes.string.isRequired,
  workspaceId: PropTypes.string,
  name: PropTypes.string,
  enrollmentType: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  createdAt: PropTypes.string,
  finishedDate: PropTypes.string,
  enrollmentsCount: PropTypes.number,
  creator: accountShape,
});

export default cohortSummaryShape;
